import type { ExecuteWorkflowNodeRequestInputs } from '@unifyapps/network/generated/models/executeWorkflowNodeRequestInputs';
import { executeWorkflowNode } from '@unifyapps/network/generated/workflow-rest-api/workflow-rest-api';
import { useGetMutationMeta } from '@unifyapps/network/hooks/useGetMutationMeta';
import type { UseMutationOptions } from '@unifyapps/network/react-query';
import { useMutation } from '@unifyapps/network/react-query';
import type { QueryMeta } from '@unifyapps/network/utils/fetch/types';

type ExecuteWorkflowNodeRequestInputsWithMeta = ExecuteWorkflowNodeRequestInputs & {
  debugParams?: Record<string, string | undefined>;
  meta?: QueryMeta;
};

export default function useExecuteNode(
  options?: UseMutationOptions<
    Awaited<ReturnType<typeof executeWorkflowNode>>,
    unknown,
    ExecuteWorkflowNodeRequestInputsWithMeta
  >,
  requestInputs?: ExecuteWorkflowNodeRequestInputs,
) {
  const meta = useGetMutationMeta();

  return useMutation<
    Awaited<ReturnType<typeof executeWorkflowNode>>,
    unknown,
    ExecuteWorkflowNodeRequestInputsWithMeta
  >({
    ...options,
    mutationFn: (inputs: ExecuteWorkflowNodeRequestInputsWithMeta) => {
      const { debugParams, meta: requestMeta, ...restInputs } = inputs;

      return executeWorkflowNode(
        {
          context: { appName: 'callables', resourceName: 'callables_call_automation' },
          inputs: restInputs,
          ...(requestInputs ?? {}),
        },
        { meta: { ...meta, ...requestMeta }, debugParams  },
      );
    },
  });
}
